import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Login from "./Login";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  Hub,
  NetworkCheck,
  Share,
  SyncAlt,
  CloudSync,
} from "@mui/icons-material";
import SupportStaff from "./SupportStaff";
import REB_Logo from "../../assets/REB_Logo.png";
import RTB_Logo from "../../assets/RTB_Logo.png";
import tmis_hero from "../../assets/tmis_hero.jpeg";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ChildFriendlyIcon from "@mui/icons-material/ChildFriendly";
import SchoolIcon from "@mui/icons-material/School";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const Home = ({ supportDeskSettings }) => {
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showSupportStaffDialog, setShowSupportStaffDialog] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 15) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const CHATBOT_SDK_SRC = "https://sdk.tmis.reb.rw/chatbot-sdk.umd.js";

    function loadScriptIfNotExists() {
      const scriptSrc = CHATBOT_SDK_SRC;

      // Check if the script already exists in the document
      if (document.querySelector(`script[src="${scriptSrc}"]`)) {
        console.log("Chatbot SDK widget script is already loaded.");
        return;
      }

      const script = document.createElement("script");

      // Set the async property correctly
      script.async = true;
      script.src = scriptSrc;

      // Define other script attributes
      const attributes = {
        "data-use-proxy": "false",
        "data-api-url": "https://sdk.tmis.reb.rw/api",
        "data-app_key": "YOUR_APP_KEY_OR_TOKEN",
        "data-position": "right",
        "data-project-name": "Ask TMIS AI",
        "data-project-color": "rgb(0, 29, 64)",
        "data-widget-width": "400",
        "data-widget-height": "500",
        "data-background-color": "#ffffff",
        "data-chat-background-color": "#ffffff",
        "data-header-color": "rgb(0, 29, 64)",
        "data-font-family": "Arial, sans-serif",
        "data-font-size": "14",
        "data-header-font-family": "Arial, sans-serif",
        "data-header-font-size": "14",
        "data-suggested-prompts": JSON.stringify([
          "List preferred districts for me",
          "Show vacancies by district and subject",
          "Match candidate to available vacancies",
        ]),
        "data-ticket-url": "https://tmis.reb.rw/",
        "data-enable-event-stream": "false",
      };

      // Set attributes on the script element
      Object.entries(attributes).forEach(([k, v]) => script.setAttribute(k, v));
      document.head.appendChild(script);
    }

    loadScriptIfNotExists();

    return () => {
      try {
        const sdk = window.ChatbotSDK?.getChatbotSDK?.();
        sdk?.destroy?.();
      } catch (e) {
        // ignore widget cleanup errors
      }

      // Remove widget container if it still exists
      const widgetEl = document.getElementById("chatbot-ai-widget");
      if (widgetEl?.parentNode) widgetEl.parentNode.removeChild(widgetEl);

      // Remove widget stylesheet injected by SDK
      const styleEl = document.getElementById("chatbot-sdk-style");
      if (styleEl?.parentNode) styleEl.parentNode.removeChild(styleEl);

      // Remove the SDK script tag to avoid persisting across pages
      const scriptEl = document.querySelector(`script[src="${CHATBOT_SDK_SRC}"]`);
      if (scriptEl?.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    };
  }, []);

  return (
    <React.Fragment>
      <div>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-9ndCyUaIbzAi2FUVXJi0CjmCapSmO7SnpJef0486qhLnuZ2cdeRhO02iuK6FUUVM"
          crossOrigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <header
          className={`fixed-top transition ${
            isScrolled ? "bg-white elevated-2 py-2" : "bg-transparent py-3"
          }`}
          style={{ transition: "all 0.3s ease" }}
        >
          <div className="container d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div className="d-flex align-items-center gap-2 logo">
              <Link to="/">
                <img
                  src={REB_Logo}
                  alt="REB Logo"
                  style={{
                    height: "75px",
                    width: "auto",
                    filter: !isScrolled
                      ? "brightness(200%)"
                      : "brightness(100%)",
                  }}
                />
                <img
                  className="ml-2"
                  src={RTB_Logo}
                  alt="RTB Logo"
                  style={{
                    height: "70px",
                    width: "auto",
                    filter: !isScrolled
                      ? "brightness(200%)"
                      : "brightness(100%)",
                  }}
                />
              </Link>
            </div>

            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
              <div
                onClick={() => setShowSupportStaffDialog(true)}
                className="mr-1 d-flex align-items-center gap-2 btn btn-primary rounded-pill px-4 py-2 shadow"
                style={{ cursor: "pointer" }}
              >
                <PhoneIcon style={{ fontSize: "18px" }} />
                <span className="fw-medium">
                  SUPPORT <span className="d-none d-md-inline">STAFF</span>
                </span>
              </div>
              {supportDeskSettings && supportDeskSettings.enabled && (
                <Link
                  to="/support-desk"
                  className="d-flex align-items-center gap-2 btn rounded-pill px-4 py-2 shadow"
                  style={{
                    background: "linear-gradient(100deg, #F16522 0%, #F7941E 100%)",
                    color: "white",
                    textDecoration: "none",
                    fontWeight: 600,
                    fontSize: "1rem",
                  }}
                >
                  <HelpOutlineIcon style={{ fontSize: "18px" }} />
                  <span className="fw-medium">SUPPORT DESK</span>
                </Link>
              )}
              <Link
                to="/training-provider"
                style={{
                  background:
                    "linear-gradient(to right, rgb(81 231 215), rgb(253, 126, 20))",
                  color: "white",
                  padding: "0.75rem 2rem",
                  borderRadius: "50px",
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  boxShadow: "0 8px 32px rgba(253,126,20,0.12)",
                  transition: "all 0.3s",
                  textDecoration: "none",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.querySelector(".arrow").style.transform =
                    "translateX(4px)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.querySelector(".arrow").style.transform = "";
                }}
              >
                <span className="d-flex align-items-center gap-2">
                  <WorkspacePremiumIcon
                    style={{ fontSize: "18px" }}
                    // className="mr-2"
                  />
                  TRAINING PROVIDER
                </span>
              </Link>
            </div>

            {/* <div
              onClick={() => setShowSupportStaffDialog(true)}
              className="d-flex align-items-center gap-2 btn btn-primary rounded-pill px-4 py-2 shadow"
              style={{ cursor: "pointer" }}
            >
              <WorkspacePremiumIcon style={{ fontSize: "18px" }} />
              <span className="fw-medium">TRAINING PROVIDER</span>
            </div> */}
          </div>
        </header>

        <section
          className="position-relative"
          style={{
            paddingTop: "10rem",
            paddingBottom: "0rem",
            backgroundColor: "#001d40",
            overflow: "hidden",
            minHeight: "580px",
          }}
        >
          <div className="position-absolute" style={{ inset: 0, zIndex: 0 }}>
            <div
              className="position-absolute"
              style={{
                top: "80px",
                right: "80px",
                width: "320px",
                height: "320px",
                background: "#fd7e14",
                borderRadius: "50%",
                mixBlendMode: "multiply",
                filter: "blur(120px)",
                opacity: "0.18",
                animation: "blob 7s infinite",
              }}
            ></div>
            <div
              className="position-absolute"
              style={{
                bottom: "80px",
                left: "80px",
                width: "320px",
                height: "320px",
                background: "#0d6efd",
                borderRadius: "50%",
                mixBlendMode: "multiply",
                filter: "blur(120px)",
                opacity: "0.18",
                animation: "blob 7s infinite 2s",
              }}
            ></div>
          </div>

          <div className="container position-relative" style={{ zIndex: 1 }}>
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0 text-center text-lg-start">
                <h1
                  className="display-3 fw-bold mb-3"
                  style={{
                    background:
                      "linear-gradient(90deg, #fd7e14 30%, #e76f51 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    letterSpacing: "1px",
                    lineHeight: 1.1,
                  }}
                >
                  Welcome to TMIS
                </h1>
                <h2
                  className="h4 fw-bold text-white mb-3"
                  style={{ letterSpacing: ".5px" }}
                >
                  Transforming Teacher Management in Rwanda
                </h2>
                <p
                  className="fs-5 text-white-50 mb-4"
                  style={{ maxWidth: 540, margin: "0 auto 2rem 0" }}
                >
                  Rwanda’s trusted platform for efficient teacher management
                  centralizing recruitment, deployment, and career support to
                  strengthen education nationwide.
                </p>

                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div
                      onClick={() => setShowSupportStaffDialog(true)}
                      className="d-flex align-items-center gap-2 btn btn-primary rounded-pill px-4 py-2 shadow"
                      style={{ cursor: "pointer" }}
                    >
                      <PhoneIcon style={{ fontSize: "18px" }} />
                      <span className="fw-medium">
                        CONTACT{" "}
                        <span className="d-none d-md-inline">SUPPORT</span>
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "1.5px",
                      height: "28px",
                      background: "#e9ecef",
                      margin: "0 10px",
                    }}
                    className="d-none d-md-block"
                  ></div>
                  <div className="d-flex flex-column flex-md-row gap-3 justify-content-center justify-content-lg-start">
                    <button
                      onClick={() => setShowLoginDialog(true)}
                      className="btn btn-lg d-flex align-items-center gap-2 border-0 shadow-lg"
                      style={{
                        background:
                          "linear-gradient(to right, #e76f51, #fd7e14)",
                        color: "white",
                        padding: "0.75rem 2rem",
                        borderRadius: "50px",
                        fontWeight: 600,
                        fontSize: "1.1rem",
                        boxShadow: "0 8px 32px rgba(253,126,20,0.12)",
                        transition: "all 0.3s",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.querySelector(
                          ".arrow",
                        ).style.transform = "translateX(4px)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.querySelector(
                          ".arrow",
                        ).style.transform = "";
                      }}
                    >
                      LOGIN
                      <ArrowForwardIcon
                        className="arrow"
                        style={{
                          fontSize: "20px",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-none d-md-flex justify-content-center align-items-center">
                <div
                  className="position-relative"
                  style={{
                    width: "100%",
                    margin: "0 auto",
                  }}
                >
                  <img
                    src={tmis_hero}
                    alt="TMIS Dashboard"
                    className="img-fluid rounded-4"
                    style={{
                      boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
                      border: "1px solid #fd7e14",
                      width: "100%",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "-30px",
                      right: "-30px",
                      background:
                        "linear-gradient(135deg, #fd7e14 60%, #e76f51 100%)",
                      borderRadius: "50%",
                      width: "64px",
                      height: "64px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 16px rgba(253,126,20,0.18)",
                      zIndex: 2,
                      border: "4px solid #fff",
                    }}
                  >
                    <i
                      className="fas fa-chalkboard-teacher text-white"
                      style={{ fontSize: 32 }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>{`
            @keyframes blob {
              0% {
                transform: scale(1);
              }
              33% {
                transform: scale(1.1);
              }
              66% {
                transform: scale(0.9);
              }
              100% {
                transform: scale(1);
              }
            }
            @keyframes pulse {
              0% {
                box-shadow: 0 0 0 0 rgba(253, 126, 20, 0.18);
              }
              70% {
                box-shadow: 0 0 0 16px rgba(253, 126, 20, 0);
              }
              100% {
                box-shadow: 0 0 0 0 rgba(253, 126, 20, 0.18);
              }
            }
          `}</style>
        </section>

        <div>
          <section style={{ background: "#f8f9fa" }}>
            <div className="container py-5">
              <div className="text-center mb-5">
                <h6
                  className="text-uppercase fw-bold"
                  style={{ color: "#fd7e14" }}
                >
                  Key Features
                </h6>
                <h2
                  className="display-5 fw-bold mb-4"
                  style={{ color: "#001d40" }}
                >
                  Comprehensive Teacher Management
                </h2>
                <p
                  className="lead text-muted mx-auto"
                  style={{ maxWidth: "700px" }}
                >
                  TMIS provides an integrated solution for managing teacher
                  data, promoting transparency, and enabling evidence-based
                  decision making.
                </p>
              </div>

              <div className="row g-4">
                {[
                  {
                    icon: "fa-users-cog",
                    title: "Post Distribution",
                    description:
                      "Helps REB and RTB plan and share budget posts by district and qualification level, ensuring proper allocation approved by MINECOFIN.",
                  },
                  {
                    icon: "fa-tasks",
                    title: "Post Management",
                    description:
                      "Enables adding new positions, registering teachers, and managing approved job positions with real-time updates.",
                  },
                  {
                    icon: "fa-exchange-alt",
                    title: "Teacher Transfers",
                    description:
                      "Streamlined transfer requests with document verification and automated ranking system for fair allocation.",
                  },
                  {
                    icon: "fa-baby-carriage",
                    title: "Maternity Leave",
                    description:
                      "Simplified process for maternity leave requests with automated replacement planning system.",
                  },
                  {
                    icon: "fa-graduation-cap",
                    title: "Scholarship Management",
                    description:
                      "Support teacher career growth through scholarship programs with integrated replacement planning.",
                  },
                  {
                    icon: "fa-chalkboard",
                    title: "Continuing Professional Development",
                    description:
                      "Plan, organize, and track teacher training programs to ensure continuous skill development and improved classroom performance.",
                  },
                ].map((feature, index) => (
                  <div key={index} className="col-lg-4 col-md-6">
                    <div className="card h-100 border-0 rounded-4 shadow-sm hover-card">
                      <div className="card-body p-4">
                        <div
                          className="feature-icon-wrapper mb-4"
                          style={{
                            background:
                              "linear-gradient(135deg, rgba(253, 126, 20, 0.1), rgba(231, 111, 81, 0.1))",
                            borderRadius: "16px",
                            padding: "1.5rem",
                            display: "inline-block",
                          }}
                        >
                          <i
                            className={`fas ${feature.icon} fa-2x`}
                            style={{ color: "#fd7e14" }}
                          ></i>
                        </div>
                        <h4 className="mb-3" style={{ color: "#001d40" }}>
                          {feature.title}
                        </h4>
                        <p className="text-muted mb-0">{feature.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <section style={{ background: "white" }}>
            <div className="container py-5">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h6
                    className="text-uppercase fw-bold"
                    style={{ color: "#fd7e14" }}
                  >
                    System Integration
                  </h6>
                  <h2
                    className="display-5 fw-bold mb-4"
                    style={{ color: "#001d40" }}
                  >
                    Seamless Integration with National Systems
                  </h2>
                  <p className="lead text-muted mb-4">
                    TMIS is integrated with key national systems to ensure
                    accurate and efficient teacher management.
                  </p>
                  <div className="d-flex flex-column gap-4">
                    {[
                      {
                        title: "NIDA Integration",
                        description:
                          "Connected with National Identification Agency for verified teacher information",
                      },
                      {
                        title: "IPPIS Integration",
                        description:
                          "Connected with Integrated Personnel and Payroll Information System for accurate personnel and payroll information data synchronization",
                      },
                    ].map((item, index) => (
                      <div key={index} className="d-flex gap-3">
                        <div
                          style={{
                            minWidth: "48px",
                            height: "48px",
                            background:
                              "linear-gradient(135deg, rgba(253, 126, 20, 0.1), rgba(231, 111, 81, 0.1))",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "#fd7e14" }}
                          ></i>
                        </div>
                        <div>
                          <h5 className="mb-2" style={{ color: "#001d40" }}>
                            {item.title}
                          </h5>
                          <p className="text-muted mb-0">{item.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-lg-6 d-none d-md-block">
                  <div className="position-relative">
                    <div
                      style={{
                        position: "absolute",
                        width: "80%",
                        height: "80%",
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(135deg, rgba(253, 126, 20, 0.1), rgba(231, 111, 81, 0.1))",
                        borderRadius: "24px",
                        zIndex: 0,
                      }}
                    ></div>
                    <div
                      className="d-flex align-items-center justify-content-center position-relative"
                      style={{
                        height: "400px",
                        zIndex: 1,
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #fd7e14 60%, #0d6efd 100%)",
                          borderRadius: "50%",
                          width: "140px",
                          height: "140px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 8px 32px rgba(13,110,253,0.10)",
                          border: "6px solid #fff",
                        }}
                      >
                        <Hub
                          style={{
                            fontSize: "4rem",
                            color: "#fff",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          top: "12%",
                          left: "22%",
                          background: "#fff",
                          borderRadius: "50%",
                          width: "60px",
                          height: "60px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                          animation: "float 3s infinite ease-in-out",
                        }}
                      >
                        <NetworkCheck
                          style={{
                            fontSize: "2rem",
                            color: "#fd7e14",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "18%",
                          right: "18%",
                          background: "#fff",
                          borderRadius: "50%",
                          width: "60px",
                          height: "60px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                          animation: "float 3s infinite ease-in-out 1.5s",
                        }}
                      >
                        <Share
                          style={{
                            fontSize: "2rem",
                            color: "#0d6efd",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          top: "10%",
                          right: "25%",
                          background: "#fff",
                          borderRadius: "50%",
                          width: "54px",
                          height: "54px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                          animation: "floatX 3.5s infinite ease-in-out 0.7s",
                        }}
                      >
                        <SyncAlt
                          style={{
                            fontSize: "1.7rem",
                            color: "#e76f51",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "12%",
                          left: "18%",
                          background: "#fff",
                          borderRadius: "50%",
                          width: "54px",
                          height: "54px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                          animation: "floatX 3.5s infinite ease-in-out 2s",
                        }}
                      >
                        <CloudSync
                          style={{
                            fontSize: "1.7rem",
                            color: "#0d6efd",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <style>{`
                    @keyframes float {
                      0% {
                        transform: translateY(0px);
                      }
                      50% {
                        transform: translateY(-14px);
                      }
                      100% {
                        transform: translateY(0px);
                      }
                    }
                    @keyframes floatX {
                      0% {
                        transform: translateX(0px);
                      }
                      50% {
                        transform: translateX(14px);
                      }
                      100% {
                        transform: translateX(0px);
                      }
                    }
                  `}</style>
                </div>
              </div>
            </div>
          </section>
          <section style={{ background: "#f8f9fa" }}>
            <div className="container py-5">
              <div className="row align-items-center">
                <div
                  className="col-lg-4 d-none d-md-flex align-items-center justify-content-center"
                  style={{ minHeight: 320 }}
                >
                  <BarChartIcon
                    sx={{
                      fontSize: { xs: 120, md: 180, lg: 220 },
                      color: "#fd7e14",
                      opacity: 0.18,
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />
                </div>
                <div className="col-lg-8 col-12">
                  <h6
                    className="text-uppercase fw-bold"
                    style={{ color: "#fd7e14" }}
                  >
                    Data for Better Schools
                  </h6>
                  <h2
                    className="display-5 fw-bold mb-4"
                    style={{ color: "#001d40" }}
                  >
                    Smart Decisions, Less Paperwork
                  </h2>
                  <p className="lead text-muted mb-5" style={{ maxWidth: 600 }}>
                    TMIS gives school leaders and government up-to-date
                    information about teachers, making it easier to plan,
                    manage, and improve education for everyone.
                  </p>
                  <div className="row g-4">
                    <div className="col-md-4">
                      <div
                        className="bg-white rounded-4 p-4 h-100 shadow-sm text-center"
                        style={{ color: "#001d40" }}
                      >
                        <BarChartIcon
                          sx={{ fontSize: 32, color: "#fd7e14", mb: 1 }}
                        />
                        <h5 className="fw-bold mb-2">Real-Time Dashboards</h5>
                        <p className="mb-0" style={{ fontSize: "1rem" }}>
                          See up-to-date information about teachers, vacancies,
                          and schools at a glance.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div
                        className="bg-white rounded-4 p-4 h-100 shadow-sm text-center"
                        style={{ color: "#001d40" }}
                      >
                        <AssessmentIcon
                          sx={{ fontSize: 32, color: "#fd7e14", mb: 1 }}
                        />
                        <h5 className="fw-bold mb-2">Less Paperwork</h5>
                        <p className="mb-0" style={{ fontSize: "1rem" }}>
                          All teacher information is stored safely online,
                          reducing manual work and errors.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div
                        className="bg-white rounded-4 p-4 h-100 shadow-sm text-center"
                        style={{ color: "#001d40" }}
                      >
                        <DashboardIcon
                          sx={{ fontSize: 32, color: "#fd7e14", mb: 1 }}
                        />
                        <h5 className="fw-bold mb-2">Trusted Data</h5>
                        <p className="mb-0" style={{ fontSize: "1rem" }}>
                          TMIS connects with national systems to keep teacher
                          data accurate and up to date.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section style={{ background: "#fff" }}>
            <div className="container pt-5 pb-2">
              <div className="text-center mb-5">
                <h6
                  className="text-uppercase fw-bold"
                  style={{ color: "#fd7e14" }}
                >
                  Teacher Services & Support
                </h6>
                <h2
                  className="display-5 fw-bold mb-4"
                  style={{ color: "#001d40" }}
                >
                  Making Life Easier for Teachers and Schools
                </h2>
                <p
                  className="lead text-muted mx-auto"
                  style={{ maxWidth: "700px" }}
                >
                  TMIS helps teachers and school leaders with everyday
                  needs—like transfers, leave, and career opportunities—so they
                  can focus on teaching and learning.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-9">
                  <div
                    style={{
                      borderLeft: "4px solid rgb(244, 216, 194)",
                      paddingLeft: "2.5rem",
                      background:
                        "linear-gradient(90deg, rgba(253,126,20,0.04) 0, #fff 100%)",
                      boxShadow: "0 2px 16px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      className="d-flex align-items-start feature-hover"
                      style={{
                        transition: "background 0.2s",
                        borderRadius: "1rem",
                        padding: "2rem 0",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 54,
                          height: 54,
                          background: "#fd7e14",
                          borderRadius: "16px",
                          marginRight: 28,
                          flexShrink: 0,
                          boxShadow: "0 2px 8px rgba(253,126,20,0.10)",
                        }}
                      >
                        <SwapHorizIcon sx={{ color: "#fff", fontSize: 30 }} />
                      </span>
                      <div>
                        <h5
                          className="fw-bold mb-1"
                          style={{ color: "#001d40", fontSize: "1.25rem" }}
                        >
                          Easy Transfers
                        </h5>
                        <p
                          className="text-muted mb-0"
                          style={{ fontSize: "1.07rem" }}
                        >
                          Teachers can request to move to a different school
                          online, with a fair and transparent process.
                        </p>
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-start feature-hover"
                      style={{
                        transition: "background 0.2s",
                        borderRadius: "1rem",
                        padding: "1rem 0",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 54,
                          height: 54,
                          background: "#0d6efd",
                          borderRadius: "16px",
                          marginRight: 28,
                          flexShrink: 0,
                          boxShadow: "0 2px 8px rgba(13,110,253,0.10)",
                        }}
                      >
                        <ChildFriendlyIcon
                          sx={{ color: "#fff", fontSize: 30 }}
                        />
                      </span>
                      <div>
                        <h5
                          className="fw-bold mb-1"
                          style={{ color: "#001d40", fontSize: "1.25rem" }}
                        >
                          Maternity Leave
                        </h5>
                        <p
                          className="text-muted mb-0"
                          style={{ fontSize: "1.07rem" }}
                        >
                          Women teachers can easily request maternity leave and
                          schools can plan for replacements in advance.
                        </p>
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-start feature-hover"
                      style={{
                        transition: "background 0.2s",
                        borderRadius: "1rem",
                        padding: "2rem 0",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 54,
                          height: 54,
                          background: "#e76f51",
                          borderRadius: "16px",
                          marginRight: 28,
                          flexShrink: 0,
                          boxShadow: "0 2px 8px rgba(231,111,81,0.10)",
                        }}
                      >
                        <SchoolIcon sx={{ color: "#fff", fontSize: 30 }} />
                      </span>
                      <div>
                        <h5
                          className="fw-bold mb-1"
                          style={{ color: "#001d40", fontSize: "1.25rem" }}
                        >
                          Career Opportunities
                        </h5>
                        <p
                          className="text-muted mb-0"
                          style={{ fontSize: "1.07rem" }}
                        >
                          TMIS helps teachers access scholarships and other
                          programs for professional growth.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style>{`
            .hover-card {
              transition:
                transform 0.3s ease,
                box-shadow 0.3s ease;
              cursor: pointer;
            }
            .hover-card:hover {
              transform: translateY(-10px);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
            }
            .btn {
              transition:
                transform 0.3s ease,
                box-shadow 0.3s ease;
            }
            .btn:hover {
              transform: translateY(-2px);
              box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            }
          `}</style>
        </div>

        <footer
          style={{
            background: "#fff",
            color: "#001d40",
            paddingTop: "2.5rem",
            paddingBottom: "1.5rem",
            marginTop: "3rem",
            boxShadow: "0 -10px 20px -5px rgba(0,0,0,0.04)",
          }}
        >
          <div className="container">
            <div className="row align-items-center mb-4">
              <div className="col-md-4 text-center text-md-start mb-3 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start gap-3">
                <img
                  src={REB_Logo}
                  alt="REB Logo"
                  style={{
                    height: "70px",
                    width: "auto",
                    filter: "brightness(1)",
                  }}
                />
                <img
                  src={RTB_Logo}
                  alt="RTB Logo"
                  style={{
                    height: "70px",
                    width: "auto",
                    filter: "brightness(1)",
                  }}
                />
              </div>
              <div className="col-md-4 text-center mb-3 mb-md-0">
                <p
                  className="mb-0"
                  style={{ fontSize: "1.05rem", color: "#001d40" }}
                >
                  <span style={{ color: "#fd7e14", fontWeight: 600 }}>
                    TMIS
                  </span>{" "}
                  – Empowering Rwanda’s education through smart teacher
                  management.
                </p>
              </div>
              <div className="col-md-4 text-center text-md-end">
                <Link
                  to="/teacher-vacants"
                  className="text-decoration-none me-3"
                  style={{
                    color: "#fd7e14",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "color 0.2s",
                  }}
                  // onClick={() => setShowSupportStaffDialog(true)}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#e76f51")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#fd7e14")}
                >
                  Teacher Vacants
                </Link>
                <span
                  className="text-decoration-none me-3"
                  style={{
                    color: "#fd7e14",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "color 0.2s",
                  }}
                  onClick={() => setShowSupportStaffDialog(true)}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#e76f51")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#fd7e14")}
                >
                  Support
                </span>
                <span
                  className="text-decoration-none me-3"
                  style={{
                    color: "#fd7e14",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "color 0.2s",
                  }}
                  onClick={() => setShowLoginDialog(true)}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#e76f51")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#fd7e14")}
                >
                  Login
                </span>
              </div>
            </div>
            <hr style={{ borderColor: "rgba(0,0,0,0.08)" }} />
            <div className="row">
              <div className="col-12 text-center">
                <small style={{ color: "#001d40" }}>
                  &copy; {new Date().getFullYear()} All rights reserved.
                </small>
              </div>
            </div>
          </div>
        </footer>

        <style>{`
          @keyframes blob {
            0% {
              transform: scale(1);
            }
            33% {
              transform: scale(1.1);
            }
            66% {
              transform: scale(0.9);
            }
            100% {
              transform: scale(1);
            }
          }
          @keyframes pulse {
            0% {
              opacity: 0.7;
            }
            50% {
              opacity: 0.4;
            }
            100% {
              opacity: 0.7;
            }
          }
          .hover-shadow:hover {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          }
        `}</style>
      </div>
      {showLoginDialog && (
        <Login
          showLoginDialog={showLoginDialog}
          setShowLoginDialog={setShowLoginDialog}
        />
      )}
      {showSupportStaffDialog && (
        <SupportStaff
          showSupportStaffDialog={showSupportStaffDialog}
          setShowSupportStaffDialog={setShowSupportStaffDialog}
        />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ supportDeskSettings }) => ({ supportDeskSettings });
export default connect(mapStateToProps)(Home);
